import React, { useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import '../assets/calendar.css'
import RCalendar from 'react-calendar';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

type Props = {
    value: Value;
    onChange: (value: Value, event?: React.MouseEvent<HTMLButtonElement> | null) => void;
    selectRange?: boolean;
    futureOnly?: boolean;
};

export const Calendar: (props: Props) => JSX.Element =({value, onChange, selectRange = true, futureOnly = false}) => {    
    const today = new Date();
    today.setHours(0,0,0,0);

    return <RCalendar 
        {...(futureOnly ? {minDate: today} : {maxDate: today})} 
        selectRange={selectRange} 
        onChange={onChange} 
        value={value} 
    />;
};
